import type { StateTree } from '@makemydeal/dr-dash-types';
import type { FailedOfferUpdateState } from '../types/orders';

const getBaseDealState = (state: StateTree): FailedOfferUpdateState => {
    return state.baseDeal;
};

export const getShowFailedUpdateOfferModal = (state: StateTree): boolean => {
    const failedOfferUpdateState = getBaseDealState(state);
    return failedOfferUpdateState?.showFailedUpdateOfferModal || false;
};
